export const NOTE_PARAMS = '?category=note'
export const TASK_PARAMS = '?category=task'
export const BOOKMARK_PARAMS = '?category=bookmark'
